<template>
        <div class="d-flex flex-column">
            <b-col cols="12" v-if="exibirSalvarArquivoUsuario" class="mb-3 d-flex" style="justify-content: flex-end;">
                <b-button  @click="fecharSalvarArquivosUsuario">Voltar</b-button>
            </b-col>
			<h4 class="mb-3" v-if="exibirSalvarArquivoUsuario">Salvar Novo Arquivo</h4>
            <salvar-arquivos-usuario :usuario="usuario" v-if="exibirSalvarArquivoUsuario"/>
            <div v-if="!exibirSalvarArquivoUsuario" class="d-flex flex-column">
                <b-col md="6" sm="12">
                    <b-button variant="primary" @click="exibirSalvarArquivoUsuario = true">Enviar Novo Arquivo</b-button>
                </b-col>
                <b-table class="mt-5 py-5" striped hover :items="arquivosUsuario" :fields="fields" show-empty :responsive="true" :busy="carregando">
                    <template #empty>
                        <div class="d-flex">
                            <span class="mx-auto">
                                Nenhum Arquivo Encontrado
                            </span>
                        </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(nome)="data">{{ data.item.nome + data.item.extensao }}</template>
                    <template #cell(dataInicio)="data">{{  $options.filters.moment(data.item.dataInicio).format("DD/MM/YYYY HH:mm") }}</template>
                    <template #cell(acao)="data">
                        <b-dropdown variant="secondary" text="Selecione" @click="data" boundary="window">
                        	<b-dropdown-item @click="baixarArquivo(data.item.id)">
								<font-awesome-icon icon="fa-solid fa-download" />
								Baixar
							</b-dropdown-item>
							<b-dropdown-item @click="abrirModalVisualizarDescricao(data.item.id)">
								<font-awesome-icon icon="fa-solid fa-file" />
								Visualizar Descrição
							</b-dropdown-item>
							<b-dropdown-item @click="abrirModalAtualizarDescricaoArquivo(data.item)">
								<font-awesome-icon icon="fa-solid fa-pen-to-square" />
								Editar Descrição
							</b-dropdown-item>
                        	<b-dropdown-item @click="abrirModalExcluirArquivo(data.item)">
								<font-awesome-icon icon="fa-solid fa-trash" />
								Excluir
							</b-dropdown-item>
						</b-dropdown>
						<modal-visualizar-descricao-arquivo :arquivo="data.item"/>
                    </template>
                </b-table>
				<modal-excluir-arquivo ref="modalExcluirArquivo" @input="filtrarArquivosPorUsuario()"/>
				<modal-atualizar-descricao-arquivo-usuario ref="modalAtualizarDescricaoArquivo" @input="filtrarArquivosPorUsuario()"/>
                <div class="my-2 d-flex flex-column" v-if="!carregando">
                    <span>Número de arquivos: {{ numeroDeLinhasTabelaArquivosUsuarios }}</span>
                </div>
                <b-pagination @input="consultarArquivosPorUsuario" class="mx-auto" v-model="paginaAtualTabelaArquivosUsuarios" :total-rows="numeroDeLinhasTabelaArquivosUsuarios" :per-page="arquivosUsuarioPorPagina" ></b-pagination>
            </div>
        </div>
</template>

<script>
import ArquivoUsuarioService from "../../service/ArquivoUsuarioService.js";
import ModalVisualizarDescricaoArquivo from "../Arquivos/ModalVisualizarDescricaoArquivo.vue";
import ModalAtualizarDescricaoArquivoUsuario from "./ModalAtualizarDescricaoArquivoUsuario.vue";
import ModalExcluirArquivo from "./ModalExcluirArquivoUsuario.vue";
import SalvarArquivosUsuario from "./SalvarArquivosUsuario.vue";

export default {
	components: { SalvarArquivosUsuario, ModalExcluirArquivo, ModalAtualizarDescricaoArquivoUsuario, ModalVisualizarDescricaoArquivo },
	name: "TableArquivosUsuario",
	props: [ "usuario" ],
	data() {
		return {
			paginaAtualTabelaArquivosUsuarios: 1,
			numeroDeLinhasTabelaArquivosUsuarios: 0,
			arquivosUsuarioPorPagina: 15,

			fields: [
				{ label: "#", key: "index" },
			 	{ label: "Nome", key: "nome" },
				{ label: "Data/Hora De Envio", key: "dataInicio" },
				{ label: "", key: "acao" },
			],
			arquivosUsuario: [],
			carregando: false,
			exibirSalvarArquivoUsuario: false,
		};
	},
	created() {
		this.consultarArquivosPorUsuario();
	},
	methods: {
		abrirModalVisualizarDescricao(id) {
			this.$bvModal.show("modal-visualizar-descricao-arquivo-" + id);
		},
		baixarArquivo(id) {
			this.carregando = true;
			ArquivoUsuarioService.baixar(id).then((res) => {
				console.log(res.data);
				this.$fileUtils.baixarArquivo(res.data.arquivo, res.data.nome);
				this.mensagem("Download do arquivo realizado com sucesso !", "Sucesso", "success");
			}).catch((err) => {
				console.log(err);
				if (err.response) {
					this.mensagem(err.response.data, "Erro", "danger");
				} else {
					this.mensagem("Não foi possível realizar o download do arquivo nesse momento", "Erro", "danger");
				}
			}).finally(() => {
				this.carregando = false;
			});
		},
		abrirModalAtualizarDescricaoArquivo(arquivo) {
			this.$refs.modalAtualizarDescricaoArquivo.abrirModal(arquivo);
		},
		abrirModalExcluirArquivo(arquivo) {
			this.$refs.modalExcluirArquivo.abrirModal(arquivo);
		},
		fecharSalvarArquivosUsuario() {
			this.filtrarArquivosPorUsuario();
			this.exibirSalvarArquivoUsuario = false;
		},
		filtrarArquivosPorUsuario() {
			this.paginaAtualTabelaArquivosUsuarios = 1;
			this.consultarArquivosPorUsuario();
		},
		consultarArquivosPorUsuario() {
			this.carregando = true;
			ArquivoUsuarioService.consultarArquivosPorUsuario(this.usuario.id, this.paginaAtualTabelaArquivosUsuarios - 1, this.arquivosUsuarioPorPagina).then((res) => {
				this.arquivosUsuario = res.data[0];
				this.numeroDeLinhasTabelaArquivosUsuarios = res.data[1];
			}).catch(() => {
				this.mensagem("Não foi possível consultar os arquivos do usuário nesse momento", "Erro", "danger");
			}).finally(() => {
				this.carregando = false;
			});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosUsuarios/TableArquivosUsuario.vue